import api from './api'
import type { IndustryType } from '../domain/industryPresets'

export type IndustryWorkspacePreview = {
  industryKey: IndustryType; version: string; title: string; warning: string; enabled: boolean; reasonCode?: string
  components: Array<{ key: string; type: 'recommendation' | 'schedule'; label: string; configuration: Record<string, unknown> }>
  canonicalSkills: Array<{ suggestedName: string; match: { id: string; canonical_name: string } | null }>
  applied: Array<{ component_key: string; template_version: string; schedule_template_id: string | null }>
}
export async function previewIndustryWorkspace(orgId: string, industryKey: IndustryType) {
  const value=(await api.get<IndustryWorkspacePreview>(`/api/orgs/${orgId}/industry-template`, { params: { industryKey } })).data
  if(!value||typeof value.enabled!=='boolean'||typeof value.version!=='string'||!Array.isArray(value.components)||!Array.isArray(value.canonicalSkills)||!Array.isArray(value.applied)
    ||value.components.some(component=>!component||typeof component.key!=='string'||!component.configuration||typeof component.configuration!=='object')) {
    throw new Error('Workspace suggestions are unavailable. No workspace configuration was changed.')
  }
  return value
}
export async function applyIndustryWorkspace(orgId: string, payload: { industryKey: IndustryType; version: string; components: string[]; timezone: string }) {
  const value=(await api.post<{ results: Array<{ key: string; status: string; scheduleTemplateId?: string }> }>(`/api/orgs/${orgId}/industry-template/apply`, payload)).data
  if(!Array.isArray(value?.results))throw new Error('The apply response could not be confirmed. Reload before retrying.')
  return value
}
